// @flow
import * as React from 'react';
import {usePrefs} from 'docs/data';
import {Command} from './Command';

const commands = (route) => ({
  node: 'npm start',
  ruby: 'ruby server.rb',
  python: 'python3 -m flask run --port=4242',
  php: 'php -S 127.0.0.1:4242 router.php',
  dotnet: 'dotnet run',
  go: 'go run server.go',
  java: `java -cp target/stripe-${route}-1.0.0-SNAPSHOT-jar-with-dependencies.jar com.stripe.sample.Server`,
});

type RunServerCommandProps = {|
  route: string,
|};

export const RunServerCommand = ({route}: RunServerCommandProps) => {
  const {getPref} = usePrefs();
  const COMMANDS = commands(route);
  const server = getPref('lang') || 'node';

  return <Command text={COMMANDS[server] || ''} />;
};
